// extracted by mini-css-extract-plugin
var _1 = "UsersSettings_cell__EaPBM";
var _2 = "UsersSettings_container__SnWLJ";
var _3 = "UsersSettings_dateCell__do1mP";
var _4 = "UsersSettings_headerTextDetails__gwPpw";
var _5 = "UsersSettings_paginationButton__JLS2u";
var _6 = "UsersSettings_paginationButtonIcon__3dmiG";
var _7 = "UsersSettings_paginationButtonText__7-QCG";
var _8 = "UsersSettings_paginationButtonsWrapper__mecyT";
var _9 = "UsersSettings_popupWrapper__kQHXL";
var _a = "UsersSettings_wrapper__7MIQt";
export { _1 as "cell", _2 as "container", _3 as "dateCell", _4 as "headerTextDetails", _5 as "paginationButton", _6 as "paginationButtonIcon", _7 as "paginationButtonText", _8 as "paginationButtonsWrapper", _9 as "popupWrapper", _a as "wrapper" }
